export default (value, message = 'Value') => {
  if (/\s/g.test(value))
    return `${message} shouldn't contain any space`;
  return null;
};
